<template>
  <div class="x-tablelist-view" style="min-width: 880px" data-automation="deviceDebug">
    <div class="home">
      <ux-home leftWidth="500px">
        <!-- 检测设备 -->
        <div slot="left" class="debugging">
          <div class="testEquip">
            <!-- imei输入框 -->
            <div class="testInput">
              <ux-input
                class="testEquip-input"
                noSpace
                v-model="imei"
                :placeholder="$t('HT.deviceDebug.imei.placeholder')"
              ></ux-input>
              <ux-button class="testEquip-button" type="primary" @click="search"
                >{{$t('HT.deviceDebug.testEquip')}}</ux-button
              >
            </div>
            <div class="testContent">
              <!-- 未查询到imei -->
              <div v-if="flag == true">
                <span>
                  {{$t('HT.deviceDebug.text1')}}<br /><br />
                  {{$t('HT.deviceDebug.text2')}}<br /><br />{{ server }}<br /><br />
                  {{$t('HT.deviceDebug.text3')}}<br /><br />
                  SERVER,0,172.16.10.115,8090,0#
                </span>
              </div>

              <!-- 查询到imei -->
              <div v-if="showInfo == true">
                {{$t('HT.deviceDebug.text4')}}{{ '<' + deviceInfo.GPS.device_imei + '>' }}<br />
                <!-- 返回信息有APP -->
                <div v-if="deviceInfo.APP">
                  APP:<br />
                  <span class="infoShow" v-for="(val, key, i) in deviceInfo.APP">
                    {{ key }}:&nbsp;{{ val }}<br />
                  </span>
                </div>
                <!-- 返回信息有GPS -->
                <div v-if="deviceInfo.GPS">
                  GPS:<br />
                  <span class="infoShow" v-for="(val, key, i) in deviceInfo.GPS">
                    {{ key }}:&nbsp;{{ val }}<br />
                  </span>
                </div>
                <!-- 返回信息有HB -->
                <div v-if="deviceInfo.HB">
                  HB:<br />
                  <span class="infoShow" v-for="(val, key, i) in deviceInfo.HB">
                    {{ key }}:&nbsp;{{ val }}<br />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 发送指令 -->
        <div slot="right" class="showMessage" style="width: 100%; height: 100%">
          <div class="sendIns">
            <!-- 指令输入框 -->
            <div class="sendInput">
              <ux-input
                class="sendInput-input"
                noSpace
                v-model="order"
                :placeholder="$t('HT.instructions.placeholder')"
              ></ux-input>
              <ux-button class="sendInput-button" type="primary" @click="search1"
                >{{$t('HT.deviceManage.instructions')}}</ux-button
              >
            </div>
            <div class="sendContent">
              <div v-for="(data, i) in socketData">
                <span v-if="connect">
                  {
                  <p class="socketMessage">uuid:&nbsp;{{ socketData[i].uuid }}</p>
                  <p class="socketMessage">imei:&nbsp;{{ socketData[i].imei }}</p>
                  <p class="socketMessage">dump:&nbsp;{{ socketData[i].data.dump }}</p>
                  }
                </span>
              </div>
            </div>
          </div>
        </div>
      </ux-home>
    </div>
  </div>
</template>

<script>
import io from 'socket.io-client';
export default {
  data() {
    return {
      imei: '', // imei号
      order: '', // 指令
      server: '172.16.10.115:8090', // 服务器
      statusData: {}, // 检测设备
      deviceInfo: {}, // 设备信息
      flag: false, // 未查到imei是否显示
      showInfo: false, // 查到imei是否显示
      connect: false, // 是否连接
      io: '', // socket.io
      socketData: [], // socket.io数据
      filter1: {
        // 查询参数
        imei: ''
      },
      filter2: {
        // 查询参数
        cmdCode: '',
        imei: '',
        offLineInsType: 'customIns'
      }
    };
  },

  methods: {
    /**
     * 连接socket.io
     */
    connectionIO(params) {
      this.io = io.connect('http://172.16.10.115:8090', {
        timeout: 300000,
        reconnectionDelayMax: 1000,
        reconnectionDelay: 500,
        query: {
          user: 'test001',
          secret: 'test001@123',
          timestamp: new Date().getTime()
        },
        forceNew: true
      });
      this.io.on('connect', () => {
        //连接成功绑定的事件
        let imeiList = [params.imei]; // 查询imei
        var jsonObject = {
          '@class': 'com.jimi.websocketd.bean.SubscribeFilter',
          user: 'test001',
          imeiList, //imei列表必需指定, 最少一个
          exprList: [
            //表达式列表可以为空, 可以多条
            '${(appId==' + '\'CONSOLE\'' + ')}'
          ]
        };
        this.io.emit('command', jsonObject);
      });

      this.io.on('message', (data) => {
        this.socketData.push(data);
        this.showInfo = true;
        this.connect = true;
        console.log(this.socketData);
      });
    },

    /**
     * 关闭连接
     */
    disConnection() {
      this.io.on('disconnect', function () {
        console.log('disconnect');
      });
      this.io.disconnect();
    },

    /**
     * 设备检测, 判读是否关闭连接
     * @param {Object} params 请求参数
     */
    checkStatus(params) {
      if (this.io.connect) {
        this.disConnection();
        this.getStatus(params);
      } else {
        this.getStatus(params);
      }
    },

    /**
     * 检测设备
     * @param {Object} params 请求参数
     */
    getStatus(params) {
      this.$uxLoading.show();
      this.$api.device.getStatus(params).then((res) => {
        if (res.code == 10000) {
          this.statusData = res.data;
          if (this.statusData.status === 0) {
            this.showInfo = false;
            this.flag = true;
          } else {
            this.getInfo(params);
          }
        }
      });
    },

    /**
     * 查询设备信息
     * @param {Object} params 请求参数
     */
    getInfo(params) {
      this.$uxLoading.show();
      this.$api.device.getInfo(params).then((res) => {
        if (res.code == 10000) {
          this.flag = false;
          this.showInfo = true;
          this.deviceInfo = res.data;
          this.connectionIO(params);
        }
      });
    },

    /**
     * 查询设备信息
     * @param {Object} params 请求参数
     */
    getInstruction(params) {
      this.$uxLoading.show();
      this.$api.device.getInstruction(params).then((res) => {
        if (res.code == 10000) {
          console.log(res.data);
        }
      });
    },

    search() {
      this.filter1.imei = this.imei;
      this.checkStatus(this.filter1);
    },

    search1() {
      this.filter2.imei = this.filter1.imei;
      this.filter2.cmdCode = this.order;
      this.getInstruction(this.filter2);
    }
  }
};
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar {
  width: 0;
}

.home {
  width: 100%;
  flex: 1;
  height: 0;
  background-color: #ffffff;

  .debugging {
    width: 100%;
    height: 100%;
    display: flex;
    // flex-direction: column;

    .testEquip {
      display: flex;
      width: 100%;
      height: 100%;
      flex-direction: column;

      .testInput {
        min-width: 420px;

        .testEquip-input {
          width: 280px;
          margin: 20px 20px 20px 0;
        }
      }

      .testContent {
        height: 100%;
        padding: 10px 30px;
        margin: 0 30px 20px 0;
        overflow-y: auto;
        // box-sizing: border-box;
        border-width: 1px;
        border-radius: 5px;
        background: black;
        color: #fff;

        .infoShow {
          padding-left: 30px;
        }
      }
    }
  }

  .showMessage {
    width: 100%;
    height: 100%;
    display: flex;
    // flex-direction: column;

    .sendIns {
      display: flex;
      width: 100%;
      height: 100%;
      flex-direction: column;

      .sendInput {
        min-width: 420px;

        .sendInput-input {
          width: 280px;
          margin: 20px 20px 20px 0;
        }
      }

      .sendContent {
        height: 100%;
        padding: 10px 30px;
        margin-bottom: 20px;
        overflow-y: auto;
        // box-sizing: border-box;
        border-width: 1px;
        border-radius: 5px;
        background: black;
        color: #fff;

        .socketMessage {
          margin: 0 20px;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
